/**
 * The function adds a scroll event listener that checks if a certain element is out of view and adds a
 * CSS class accordingly, and also initializes a slider component.
 */
import { initStickyCardsSlider } from "../components/slider";
const scrollObserver = () => {
    window.addEventListener('scroll', function () {
		const cards = document.querySelectorAll('.start-cards__card');
		let startSticky = document.getElementById('start-sticky__bar');
		const cardsPosition = cards[0].getBoundingClientRect();
		if (cardsPosition.bottom < 0) {
			startSticky.classList.add("sticky");
		} else {
			startSticky.classList.remove("sticky");
		}
	});
}

scrollObserver();
initStickyCardsSlider();